// @flow
import type { DataFieldNameSearch } from "./DataFieldFilter";
import React, { Fragment } from "react";
import { fetchJson } from "../../lib/Fetching";
import styled from "styled-components";
import DropDown from "../DropDown";
import Input from "../Input";
import { Container, Row, Col } from "react-grid-system";
import DataFieldDropDown from "./DataFieldDropDown";
import { Cancel } from "styled-icons/material/Cancel";

const DeleteIcon = styled(Cancel).attrs({ size: 23 })`
  margin-top: 6px;
  color: red;
  cursor: pointer;
`;

const DataField = styled.div`
  padding-top: 7px;
  padding-bottom: 7px;
`;

const containerStyle = {
  paddingLeft: 0,
  paddingRight: 0
};

type Props = {
  onSubmit: () => void,
  onDelete: () => void,
  data_field_name: DataFieldNameSearch,
  company_id: ?number
};

type State = {
  matchType: string,
  dropDownValues: Array<any>,
  freeTextValue: string
};

export default class DataFieldSearch extends React.Component<Props, State> {
  state = {
    matchType: "matches",
    dropDownValues: [],
    freeTextValue: ""
  };

  params = () => ({
    data_field_name_id: this.props.data_field_name.id,
    match_type: this.state.matchType,
    text_search: this.state.freeTextValue,
    items: this.state.dropDownValues.map(o => o.value)
  });

  matchTypes = () => [
    { label: I18n.t('matches'), value: "matches" },
    { label: I18n.t('excludes'), value: "excludes" }
  ];

  onMatchTypeChange = option =>
    this.setState({
      matchType: option.value
    });

  onDropDownChange = dropDownValues =>
    this.setState({
      dropDownValues,
      freeTextValue: ""
    });

  onFreeTextChange = e =>
    this.setState({
      dropDownValues: [],
      freeTextValue: e.target.value
    });

  render() {
    const { data_field_name, company_id, onDelete, onSubmit } = this.props;
    const { matchType, dropDownValues, freeTextValue } = this.state;
    return (
      <DataField>
        <label>{data_field_name.name}</label>
        <Container fluid style={containerStyle}>
          <Row>
            <Col sm={3}>
              <DropDown
                value={matchType}
                onChange={this.onMatchTypeChange}
                options={this.matchTypes()}
              />
            </Col>
            {company_id &&
              data_field_name.has_items && (
                <Col sm={5}>
                  <DataFieldDropDown
                    multiple={true}
                    values={dropDownValues}
                    onChange={this.onDropDownChange}
                    company_id={company_id}
                    data_field_name={data_field_name}
                  />
                </Col>
              )}
            <Col sm={3}>
              <Input
                onPressEnter={onSubmit}
                disabled={dropDownValues.length > 0}
                className="form-control"
                style={{ height: 38 }}
                placeholder="Enter search..."
                value={freeTextValue}
                onChange={this.onFreeTextChange}
              />
            </Col>
            <Col sm={1}>
              <DeleteIcon onClick={onDelete} />
            </Col>
          </Row>
        </Container>
      </DataField>
    );
  }
}
